import { Button, Carousel, Rate } from "antd";
import React, { useRef } from "react";
import {
  BsChevronLeft,
  BsChevronRight,
} from "react-icons/bs";

import styles from "../LandingV2.module.scss";

export const GoogleReviewSlider = () => {
  const reviewRef = useRef(null);
  return (
    <section className={styles.review + " dtr"}>
      <h3>Make Fresh Happen: Share</h3>
      <h3>Your Experience</h3>
      <img src="/g-review.png" alt="" className={styles.review__g_review} />
      <div style={{ width: "100%", position: "relative" }}>
        <button
          className={styles.review_slide_btn}
          onClick={() => reviewRef.current.prev()}
        >
          <BsChevronLeft size={20} />
        </button>
        <button
          className={styles.review_slide_btn}
          style={{ right: "0%" }}
          onClick={() => reviewRef.current.next()}
        >
          <BsChevronRight size={20} />
        </button>
        <Carousel
          ref={reviewRef}
          dots={false}
          responsive={[
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 2000,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
          ]}
        >
          {Array(10)
            .fill(0)
            .map((_, index) => (
              <div className={styles.review__item} key={index}>
                <img src="/review-avatar.png" alt="" />
                <span
                  style={{
                    fontSize: "1.8rem",
                    marginTop: "5px",
                    fontWeight: "600",
                  }}
                >
                  Giana Vetrovs
                </span>
                <Rate
                  style={{ color: "#FDBD13" }}
                  disabled={true}
                  defaultValue={5}
                />
                <p>
                  I was so impressed by the quality of the produce from Desi
                  Fresh. Everything was so fresh and delicious - I can't wait to
                  order again!
                </p>
                <em>
                  <img src="/icon/google-icon.svg" alt="" />3 weeks ago
                </em>
              </div>
            ))}
        </Carousel>
      </div>
      <Button
        type={"primary"}
        style={{ marginTop: "1rem", padding: "0 2.5rem" }}
      >
        Leave a Review
      </Button>
      <div className={styles.review__point}>
        <img src="/icon/family-card.png" alt="" />
        <span>Earn Desi Family 50</span>
        <img src="/icon/points-icon.svg" alt="" />
      </div>
    </section>
  );
};
